var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuPingceSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72206 0.379308C3.57488 1.11753 1.11753 3.57488 0.379308 6.72206C-0.126436 8.87814 -0.126436 11.1219 0.379307 13.278C1.11753 16.4251 3.57488 18.8824 6.72207 19.6207C8.87814 20.1264 11.1219 20.1264 13.278 19.6207C16.4251 18.8824 18.8824 16.4251 19.6207 13.278C20.1264 11.1219 20.1264 8.87814 19.6207 6.72208C18.8824 3.57488 16.4251 1.11753 13.278 0.379307C11.1219 -0.126436 8.87814 -0.126436 6.72206 0.379308ZM12.8212 2.32646C15.2289 2.89121 17.1088 4.77113 17.6735 7.17881C18.1088 9.03446 18.1088 10.9655 17.6735 12.8212C17.1088 15.2289 15.2289 17.1088 12.8212 17.6735C10.9655 18.1088 9.03446 18.1088 7.17881 17.6735C4.77113 17.1088 2.89121 15.2289 2.32646 12.8212C1.89118 10.9655 1.89118 9.03446 2.32646 7.1788C2.89121 4.77114 4.77114 2.89121 7.1788 2.32646C8.90192 1.92227 10.6901 1.8934 12.4225 2.23985L12.8212 2.32646ZM13.4323 7.26895C13.0286 6.89211 12.3958 6.91393 12.0189 7.31768L9.225 10.31L7.95711 9.0429L7.8629 8.95971C7.47061 8.65468 6.90338 8.68241 6.5429 9.0429C6.15237 9.43342 6.15237 10.0666 6.5429 10.4571L8.5429 12.4571L8.63946 12.5421C9.04171 12.8531 9.6247 12.8141 9.98106 12.4323L13.4811 8.68232L13.561 8.5853C13.8523 8.18273 13.805 7.61679 13.4323 7.26895Z",
    fill: "#F5B544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPingceSelected);
export default __webpack_public_path__ + "static/media/menu_pingce_selected.bcf992de4b1ac33b229b57d904302cd9.svg";
export { ForwardRef as ReactComponent };